import { environmentService, getRequestHandler, postRequestHandler } from '@/utils/services';
import { i18n } from '@/lang/i18n';

const DefaultState = () => {
  return {
    apiUrl: null,
    apiUrlHotel: null,
    isLogLoading:false,
    logs:[],
    hotelActivityId:null,
    hotelComments:[],
    hotelLogs:[],
    hotelLogsLoadedForId:null,
    isHotelCommentsLoading:false,
    isHotelLogsLoading:false,
    modules:[],
    actions:[],
    actionSelected:null,
    search:{
      from:null,
      to: null,
      pagination: {
        page: 1,
        per_page: 20
      },
      sort: {
        field: 'id',
        order: 'desc'
      }
    },
    total:null
  };
},

state = DefaultState(),

getters = {
  logs: state => state.logs,
  hotelComments: state => state.hotelComments,
  hotelLogs: state => state.hotelLogs,
  isHotelCommentsLoading: state => state.isHotelCommentsLoading,
  isHotelLogsLoading: state => state.isHotelLogsLoading,
  modules: state => state.modules,
  actions: state => {
    return state.actionSelected? state.actions.filter(action=>action.module_id==state.actionSelected): state.actions;
  },
  isLogLoading: state => state.isLogLoading,
  total: state => state.total,
  pagination: state => state.search.pagination,
  sort: state => state.search.sort,
  actionSelected: state => state.actionSelected
},

mutations = {
  setLogsUrls(state){
    state.apiUrl = environmentService.apiUrlLogs;
    state.apiUrlHotel = environmentService.apiUrlHotel;
  },
  setHotelActivityId(state, payload){
    state.hotelActivityId = payload;
  },
  setHotelComments(state, payload){
    state.hotelComments = payload;
  },
  setHotelLogs(state, payload){
    state.hotelLogs = payload;
  },
  setHotelLogsLoadedForId(state, payload){
    state.hotelLogsLoadedForId = payload;
  },
  setHotelCommentsLoading(state, payload){
    state.isHotelCommentsLoading = payload;
  },
  setHotelLogsLoading(state, payload){
    state.isHotelLogsLoading = payload;
  },
  removeHotelComment(state, commentId){
    state.hotelComments = state.hotelComments.filter(comment => comment.id != commentId);
  },
  resetHotelActivity(state){
    state.hotelActivityId = null;
    state.hotelComments = [];
    state.hotelLogs = [];
    state.hotelLogsLoadedForId = null;
    state.isHotelCommentsLoading = false;
    state.isHotelLogsLoading = false;
  },
  setTotal(state, payload){
    state.total = payload;
  },
  setLogs(state, payload){
    state.logs = payload;
  },
  setModules(state, payload){
    state.modules = payload;
  },
  setActions(state, payload){
    state.actions = payload;
  },
  setActionSelected(state, payload){
    state.actionSelected = payload;
  },
  setPagination(state, payload){
    state.search.pagination.page = payload;
  },

  setOrder(state, payload){
    state.search.sort.field=payload.field;
    state.search.sort.order=payload.order;
  },

  setDates(state, payload){
    const today = new Date()
    let minDateSet = new Date(today.getTime());
    minDateSet.setFullYear(today.getFullYear() - 1);
    let maxDateSet = new Date(today.getTime());
    if (payload.calendarData.dateRange.start.date && payload.calendarData.dateRange.end.date){
      state.search.from = new Date(payload.calendarData.dateRange.start.date).toISOString().split('T')[0];
      state.search.to = new Date(payload.calendarData.dateRange.end.date).toISOString().split('T')[0];
    }else{
      state.search.from = minDateSet.toISOString().split('T')[0];
      state.search.to = maxDateSet.toISOString().split('T')[0];
    };
  },

  setSearchIds(state, payload){
    if (payload.userId){
      state.search.userId = payload.userId;
    }else{
      delete state.search['moduleId'];
    };

    if (payload.moduleId){
      state.search.moduleId = payload.moduleId;
    }else{
      delete state.search['moduleId'];
    };

    if (payload.actionId){
      state.search.actionId = payload.actionId;
    }else{
      delete state.search['actionId'];
    };
    if (payload.bookingId){
      state.search.bookingId = payload.bookingId;
    }else{
      delete state.search['bookingId'];
    };
  },

  toggleLogLoading(state){
    state.isLogLoading = !state.isLogLoading;
  },

  RESET_STATE(state){
    Object.assign(state, DefaultState());
  }
},

actions = {
  setLogsUrls({ commit }){
    commit('setLogsUrls');
  },
  setActionSelected({ commit }, payload){
    commit('setActionSelected', payload);
    commit('setPagination', 1);
  },
  async getModules({ commit, state, rootState}){
    let modules = await getRequestHandler(`${state.apiUrl}/modules`, {headers: rootState.auth.headers});
    commit('setModules', modules);
  },

  async getActions({ commit, state, rootState}){
    let actions =  await getRequestHandler(`${state.apiUrl}/actions`, {headers: rootState.auth.headers});
    commit('setActions', actions);
  },

  async getHotelComments({ commit, state, rootState, dispatch }, hotelId){
    i18n.locale = rootState.global.locale;
    if (!state.apiUrlHotel) {
      commit('setLogsUrls');
    }
    commit('setHotelActivityId', hotelId);
    commit('setHotelCommentsLoading', true);
    const result = await postRequestHandler(
      `${state.apiUrlHotel}/hotels/comments`,
      { hotelId },
      { headers: rootState.auth.headers }
    );

    if (state.hotelActivityId == hotelId) {
      if (result.status == 200) {
        commit('setHotelComments', result.data || []);
      } else {
        commit('setHotelComments', []);
        dispatch(
          'global/setToastNotification',
          {
            title: i18n.t('lang.closeManagement.comments'),
            text: result.errors && result.errors.length ? result.errors[0] : i18n.t('lang.closeManagement.commentsFetchError'),
            type: 'danger'
          },
          { root: true }
        );
      }
      commit('setHotelCommentsLoading', false);
    }
    return result;
  },

  async deleteHotelComment({ commit, state, rootState, dispatch }, payload){
    i18n.locale = rootState.global.locale;
    if (!state.apiUrlHotel) {
      commit('setLogsUrls');
    }
    const result = await postRequestHandler(
      `${state.apiUrlHotel}/hotels/comments/delete`,
      {
        hotelId: payload.hotelId,
        commentId: payload.commentId
      },
      { headers: rootState.auth.headers }
    );

    if (result.status == 200) {
      commit('removeHotelComment', payload.commentId);
      dispatch(
        'global/setToastNotification',
        {
          title: i18n.t('lang.closeManagement.comments'),
          text: i18n.t('lang.closeManagement.commentDeleted'),
          type: 'success'
        },
        { root: true }
      );
    } else {
      dispatch(
        'global/setToastNotification',
        {
          title: i18n.t('lang.closeManagement.comments'),
          text: result.errors && result.errors.length ? result.errors[0] : i18n.t('lang.closeManagement.commentDeleteError'),
          type: 'danger'
        },
        { root: true }
      );
    }
    return result;
  },

  async findHotelLogs({ commit, state, rootState, dispatch }, hotelId){
    i18n.locale = rootState.global.locale;
    if (!state.apiUrl) {
      commit('setLogsUrls');
    }
    if (
      state.hotelLogsLoadedForId == hotelId ||
      (state.isHotelLogsLoading && state.hotelActivityId == hotelId)
    ) {
      return state.hotelLogs;
    }
    commit('setHotelActivityId', hotelId);
    commit('setHotelLogsLoading', true);

    const today = new Date();
    const to = [
      today.getFullYear(),
      String(today.getMonth() + 1).padStart(2, '0'),
      String(today.getDate()).padStart(2, '0')
    ].join('-');
    const payload = {
      from: '2020-01-01',
      to,
      type: 'App\\Hotel',
      typeId: hotelId,
      actionIds: [85, 86, 87, 88],
      pagination: {
        page: 1,
        per_page: 999999
      },
      sort: {
        field: 'created_at',
        order: 'desc'
      }
    };
    const result = await postRequestHandler(
      `${state.apiUrl}/logs`,
      payload,
      { headers: rootState.auth.headers }
    );

    if (state.hotelActivityId == hotelId) {
      if (result.status == 200) {
        commit('setHotelLogs', result.data.logs || []);
        commit('setHotelLogsLoadedForId', hotelId);
      } else if (result.status == 404) {
        commit('setHotelLogs', []);
        commit('setHotelLogsLoadedForId', hotelId);
      }
      commit('setHotelLogsLoading', false);
    }
    if (result.status != 200 && result.status != 404) {
      dispatch(
        'global/setToastNotification',
        {
          title: i18n.t('lang.closeManagement.logs'),
          text: i18n.t('lang.closeManagement.logsFetchError'),
          type: 'danger'
        },
        { root: true }
      );
    }
    return result.status == 200 ? result.data.logs || [] : [];
  },

  resetHotelActivity({ commit }){
    commit('resetHotelActivity');
  },

  async findLogs({ commit, state, rootState}, payload){
    commit('toggleLogLoading');
    // commit('setLogs',[]);
    if (payload){
      commit('setDates', payload.calendar);
      commit('setSearchIds', payload.fieldIds);
      commit('setPagination', payload.pagination.page);
    }
    let logs = await postRequestHandler(`${state.apiUrl}/logs`, state.search , {headers: rootState.auth.headers});
    if (logs.status==200){
      commit('setTotal', logs.data.total);
      commit('setLogs', logs.data);
    } else {
      commit('setTotal', 0)
      commit('setLogs', []);
    }
    commit('toggleLogLoading');
  },

  async paginateData({ commit, dispatch}, payload){
    commit('setPagination', payload);
    // await dispatch('findLogs');
  },

  async sortData({ commit, dispatch}, payload){
    commit('setOrder', payload);
    await dispatch('findLogs');
  },

  RESET_STATE({ commit }){
    commit('RESET_STATE');
  }
};

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/logs.js